module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAFVBMVEUAAACZmZmampqYmJiZmZmZmZmZmZm/WSaGAAAAB3RSTlMAX2DM0tP6dGUaCQAAAD1JREFUCNdjcGIAA2EGMQUQzZgEQkAA4oIwmAciIPJiChBpoBBEACgEEUAw4FIwxXDtMAPhVsAtDYJoFQUAd1sI2UAUKV0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/NewIcon2020-7/icon_close_nor@2x.png
// module id = 6rR2
// module chunks = 94